import { render, staticRenderFns } from "./right-section.vue?vue&type=template&id=f11bb642"
import script from "./right-section.vue?vue&type=script&lang=js"
export * from "./right-section.vue?vue&type=script&lang=js"
import style0 from "./right-section.vue?vue&type=style&index=0&id=f11bb642&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports